<article class="content-card-mini-readonly" [ngClass]="status" [class.declined]="invalid" [class.active]="active">
  <!--  <div *ngIf="!linkEnable && isBrowser" class="card-cover"></div>-->

  <div class="container">
    <div class="author">
      <div *ngIf="author" class="author-img">
        <on-ui-cover [cover]="cover"></on-ui-cover>
      </div>
      <div class="author-info">
        <div *ngIf="author" class="author-name normal" [attr.title]="authorFullName">
          <span>{{ authorName }}</span>
        </div>
      </div>
      <span *ngIf="!author">&nbsp;</span>
    </div>

    <div class="cover-wrap">
      <div *ngIf="isLessonSelected" class="status">{{ 'content-mini-card.added' | customLocale }}</div>
      <div *ngIf="statusTitle" class="status">{{ statusTitle | customLocale }}</div>
      <div *ngIf="isMediaTypeNecessary" class="type-content">
        <app-icon class="type-img-ico" [ngClass]="contentType" [icon]="'type-' + contentType"></app-icon>
      </div>
      <img *ngIf="coverImageUrl" [src]="coverImageUrl" [alt]="fullTitle" [title]="fullTitle" />
      <div *ngIf="!coverImageUrl" class="no-cover">
        <span>{{ 'library.no-image-text' | customLocale }}</span>
      </div>
    </div>

    <div class="meta-link" [attr.title]="fullTitle">
      <i class="subject-wrap">
        <span class="subject bold">{{ subject }}</span>
        <ng-template [ngIf]="item?.subject?.category_id === subjectCategoryEnum.native_language">
          <span class="subject-category normal">{{ 'content-mini-card.native' | customLocale }}</span>
        </ng-template>
      </i>
      <span class="title bold">{{ item.title }}</span>
      <span *ngIf="item?.sub_title?.length" class="subtitle normal">{{ item.sub_title }}</span>
      <span class="content-type-and-level normal"> {{ contentTypeTitle | customLocale }}, {{ level | customLocale }} </span>
    </div>
  </div>
</article>
